export default __webpack_public_path__ + "static/media/footer_image_5.475a2887.jpg";